import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Step as ProseMirrorStep } from '@atlaskit/editor-prosemirror/transform';
function isLockable(step) {
  return (step === null || step === void 0 ? void 0 : step.lockStep) !== undefined;
}
var createLockableProseMirrorStep = function createLockableProseMirrorStep(step) {
  var stepIsLocked = false;
  if (isLockable(step)) {
    return step;
  }
  return new Proxy(step, {
    get: function get(target, prop, receiver) {
      if (prop === 'lockStep') {
        return function () {
          stepIsLocked = true;
        };
      } else if (prop === 'isLocked') {
        return function () {
          return stepIsLocked;
        };
      }
      return Reflect.get(target, prop, receiver);
    }
  });
};

// Based on: `packages/editor/prosemirror-collab/src/index.ts`
var LockableRebaseable = /*#__PURE__*/_createClass(function LockableRebaseable(step, inverted, origin) {
  _classCallCheck(this, LockableRebaseable);
  this.step = step;
  this.inverted = inverted;
  this.origin = origin;
});
var LockableProseMirrorStep = /*#__PURE__*/function (_ProseMirrorStep) {
  function LockableProseMirrorStep() {
    _classCallCheck(this, LockableProseMirrorStep);
    return _callSuper(this, LockableProseMirrorStep, arguments);
  }
  _inherits(LockableProseMirrorStep, _ProseMirrorStep);
  return _createClass(LockableProseMirrorStep);
}(ProseMirrorStep);
/**
 * Merge a set of steps together to reduce the total number of steps stored in memory.
 *
 * All steps passing through here should be "lockable" (ie. can be locked by the document service)
 * so that it can be indicated they have already been sent (or are about to be sent) to the backend
 * and cannot be merged.
 *
 * @param steps Rebaseable steps
 * @returns Rebaseable steps
 */
export function mergeUnconfirmedSteps(steps, api) {
  var mergedSteps = steps.reduce(function (acc, rebaseable) {
    var _api$connectivity, _lastStep$step$isLock, _lastStep$step, _rebaseable$step$isLo, _rebaseable$step;
    var lastStep = acc[acc.length - 1];
    if ((api === null || api === void 0 || (_api$connectivity = api.connectivity) === null || _api$connectivity === void 0 || (_api$connectivity = _api$connectivity.sharedState.currentState()) === null || _api$connectivity === void 0 ? void 0 : _api$connectivity.mode) === 'offline' && lastStep && ((_lastStep$step$isLock = (_lastStep$step = lastStep.step).isLocked) === null || _lastStep$step$isLock === void 0 ? void 0 : _lastStep$step$isLock.call(_lastStep$step)) !== true && ((_rebaseable$step$isLo = (_rebaseable$step = rebaseable.step).isLocked) === null || _rebaseable$step$isLo === void 0 ? void 0 : _rebaseable$step$isLo.call(_rebaseable$step)) !== true) {
      var mergedStep = lastStep.step.merge(rebaseable.step);
      var _inverted = rebaseable.inverted.merge(lastStep.inverted);
      // Always take the origin of the new step.
      // We use this in packages/editor/collab-provider/src/document/document-service.ts:commitUnconfirmedSteps
      // to confirm that the last transaction has been sent. Since we're taking the latest this still works as expected
      // As we want to wait until all the transactions have been pushed through
      var _origin = lastStep.origin;
      if (mergedStep && _inverted) {
        acc[acc.length - 1] = new LockableRebaseable(createLockableProseMirrorStep(mergedStep), _inverted, _origin);
        return acc;
      }
    }
    return acc.concat(new LockableRebaseable(createLockableProseMirrorStep(rebaseable.step), rebaseable.inverted, rebaseable.origin));
  }, []);
  return mergedSteps;
}